
import { Accordion, Dialog, Link, MenuItem, MenuList, Pagination, styled } from "@mui/material";


export const StyledLink = styled(Link)({
  textDecoration: "none",
  "&:hover, &:focus, &:active, &:visited": {
    textDecoration: "none",
  },
})

export const StyledDefault = styled(Link)({
  cursor: "pointer",
  color: "#202641",
  textDecoration: "none",
  "&:hover, &:focus, &:active, &:visited": {
    textDecoration: "none",
  },
  marginTop: "10px",
})


export const StyledLinkGray = styled(Link)({
  cursor: "pointer",
  color: "rgba(255, 255, 255, 0.60)",
  textDecoration: "none",
  "&:hover": {
    color: "#FFF",
    textDecoration: "none",
  }
})


export const StyledLinkWhite = styled(Link)({
  cursor: "pointer",
  color: "white",
  textDecoration: "none",
  "&:hover, &:focus, &:active, &:visited": {
    textDecoration: "none",
  }
})

export const LinkWhiteHoverOrange = styled(Link)({
  cursor: "pointer",
  color: "white",
  textDecoration: "underline",
  
  "&:hover": {
    color: "#FF3C00"
  }
})

export const LinkGrayHoverOrange = styled(Link)({
  cursor: "pointer",
  color: "rgba(255, 255, 255, 0.60)",
  textDecoration: "underline",
  "&:hover": {
    color: "#FF3C00"
  }
})

export const LinkGrayHoverGray = styled(Link)({
  cursor: "pointer",
  color: "rgba(255, 255, 255, 0.60)",
  textDecoration: "underline",
  "&:hover": {
    color: "rgba(255, 255, 255, 0.60)"
  }
})

export const LinkWhiteHoverWhite = styled(Link)({
  cursor: "pointer",
  color: "white",
  textDecoration: "underline",
  "&:hover": {
    color: "white"
  }
})

export const StyledLinkForButton = styled(Link)({
  textDecoration: "none",
  "&:hover, &:focus, &:active, &:visited": {
    textDecoration: "none",
  }
})

export const StyledLinkWhiteIndustries = styled(Link)({
  cursor: "pointer",
  color: "white",
  textDecoration: "none",
  "&:hover, &:focus, &:active, &.active": {
    textDecoration: "none",
    color: "#C3F0F7"
  }
})

export const CenterMenuItem = styled(MenuItem)({
  minHeight: "38px",
  display: "flex",
  justifyContent: "center",
  ".MuiLink-root": {
    color: "rgba(255, 255, 255, 0.60)",
    textDecoration: "none",
  },
  "&:hover": {
    backgroundColor: "transparent",
    ".MuiLink-root": {
      color: "#FF3C00",
      textDecoration: "none",
    }
  },
  "&.Mui-disabled": {
    cursor: "default",
    opacity: "1",
  }

})

// export const CustomNavbarMenuItem = styled(MenuItem)({
//   ".MuiLink-root": {
//     color: "rgba(255, 255, 255, 0.60)",
//     textDecoration: "none",
//   },
//   "&:hover": {
//     backgroundColor: "none",
//     ".MuiLink-root": {
//       color: "#FF3C00",
//       textDecoration: "none",
//     }
//   },
//   "&.Mui-disabled": {
//     cursor: "default",
//     opacity: "1",
//   }
// })

export const CustomNavbarMenuList = styled(MenuList)({
  ".MuiMenuItem-root": {
    cursor: "default",
    paddingTop: "0px",
    paddingBottom: "0px",
    minHeight: "38px",
    "&:hover": {
      backgroundColor: "transparent",

    },
    ".MuiLink-root": {
      "&:hover": {
        cursor: "pointer",
        color: "#FF3C00",
        textDecoration: "none",
      }
    },
    "&.Mui-disabled": {
      cursor: "default",
      opacity: "1",
    },
  },
  ".MuiLink-root": {
    color: "#FFF",
    textDecoration: "none",
  },
  "&:hover": {
    ".MuiLink-root": {
      color: "rgba(255, 255, 255, 0.60)",
      textDecoration: "none",
    }
  }
})

export const CustomHomeAccordion = styled(Accordion)({
  backgroundColor: "#0E2F6C",
  "&:hover": {
    backgroundColor: "#C3F0F7",
    '.MuiAccordionSummary-root': {
      color: "#202641"
    },
    '.MuiAccordionDetails-root': {
      color: "#202641"
    },
    '.MuiSvgIcon-root': {
      color: "#202641"
    }
  },
  "&.Mui-expanded": {
    backgroundColor: "#C3F0F7",
    '.MuiAccordionSummary-root': {
      color: "#202641"
    },
    '.MuiAccordionDetails-root': {
      color: "#202641"
    },
    '.MuiSvgIcon-root': {
      color: "#202641"
    },
    '.MuiAccordionSummary-expandIconWrapper': {
      transform: "rotate(270deg)"
    }
  },
  '.MuiAccordionSummary-root': {
    color: "#FFF"
  },
  '.MuiAccordionDetails-root': {
    color: "#FFF"
  },
  '.MuiSvgIcon-root': {
    color: "#FFF"
  }
})

export const CustomDialogVideo = styled(Dialog)({
  '.MuiBackdrop-root': {
    backgroundColor: "rgba(0, 0, 0, 0.1)"
  }
})

export const CustomPagination = styled(Pagination)({
  '& ul > li:first-of-type': {
    '& button': {
      borderTopLeftRadius: "4px !important",
      borderBottomLeftRadius: "4px !important",
      '&:after': {
        marginLeft: "10px",
        content: `"Previous"`,
        color: '#8B8E9C',

      }
    }
  },
  '& ul > li:last-of-type': {
    '& button': {
      borderTopRightRadius: "4px !important",
      borderBottomRightRadius: "4px !important",
      '&:before': {
        marginRight: "10px",
        content: `"Next"`,
        color: '#8B8E9C',

      }
    }
  },
  '& .MuiPaginationItem-root': {
    color: "#8B8E9C",
    border: "1px solid #6B7280",
    borderRadius: '0px',
    margin: '0px',
    padding: '20px',
    '&.MuiPaginationItem-ellipsis': {
      display: "none"
    },
    '&:hover': {
      backgroundColor: '#0E2F6C',
    },
    '&.Mui-disabled': {
      opacity: 1,
      cursor: "not-allowed",
      pointerEvents: "auto"
    },
  },

  '& .Mui-selected': {
    backgroundColor: '#0E2F6C !important',
    color: '#8B8E9C',
    '&:hover': {
      backgroundColor: '#0E2F6C',
    },
  },
})

